import Vue from 'vue';
import uploadImage from '../components/upload/upload-image';
import uploadImages from '../components/upload/upload-images';
import uploadVideo from '../components/upload/upload-video';
import uploadAudio from '../components/upload/upload-audio';
import uploadVr from '../components/upload/upload-vr';
import uploadVrDialog from '../components/upload/components/upload-vr-dialog';
import uImage from '../components/u-image';
import vMediaVr from '../components/v-media/v-media-vr';
import vUploadImage from '../components/v-upload/v-upload-image';
import longpress from '../directives/longpress';

const custom = {
  install: function (Vue) {
    Vue.component('uploadImage', uploadImage);
    Vue.component('uploadImages', uploadImages);
    Vue.component('uploadAudio', uploadAudio);
    Vue.component('uploadVideo', uploadVideo);
    Vue.component('uploadVr', uploadVr);
    Vue.component('uploadVrDialog', uploadVrDialog);
    Vue.component('uImage', uImage);
    Vue.component('vMediaVr', vMediaVr);
    Vue.component('vUploadImage', vUploadImage);
  },
};

Vue.use(custom);
Vue.directive('longpress', longpress);
